import { GroupsEnum } from "@/enum/groups";
import { PATH_IDS } from "./path-ids";

type GroupPathKey = keyof typeof PATH_IDS & GroupsEnum;

const PATH_ENTRIES = Object.entries(PATH_IDS) as [GroupPathKey, string][];

const PATH_TO_GROUP: Record<string, GroupsEnum> = PATH_ENTRIES.reduce(
  (acc: Record<string, GroupsEnum>, [groupName, pathPrefix]) => {
    acc[pathPrefix] = groupName;
    return acc;
  },
  {}
);

export function inferModuleFromPath(pathname: string): GroupsEnum | null {
  for (const [pathPrefix, groupName] of Object.entries(PATH_TO_GROUP)) {
    if (pathname.startsWith(pathPrefix)) return groupName;
  }
  return null;
}
